import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 22,
	viewBox: "0 0 20 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "share-apple_1 2",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M13.082 5.71094L10 2.62891L6.91797 5.71094L6.10547 4.89453L10 1L13.8945 4.89453L13.082 5.71094Z",
					fill: "currentColor",
					stroke: "currentColor",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M10.582 1.8125H9.41797V14.0234H10.582V1.8125Z",
					fill: "currentColor",
					stroke: "currentColor",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M15.8125 21H4.1875C3.19922 21 2.44141 20.2422 2.44141 19.2539V8.78906C2.44141 7.80078 3.19531 7.04297 4.1875 7.04297H8.25781V8.20703H4.1875C3.83984 8.20703 3.60547 8.44141 3.60547 8.78906V19.2539C3.60547 19.6016 3.83984 19.8359 4.1875 19.8359H15.8164C16.1641 19.8359 16.3984 19.6016 16.3984 19.2539V8.78906C16.3984 8.44141 16.1641 8.20703 15.8164 8.20703H11.7461V7.04297H15.8164C16.8047 7.04297 17.5625 7.79687 17.5625 8.78906V19.2539C17.5586 20.2422 16.8008 21 15.8125 21Z",
					fill: "currentColor",
					stroke: "currentColor",
					strokeWidth: .5
				})
			]
		})
	})
});
export default SvgShare2;
